export default function (num, base) {
	let n = num
	let numWithBase = n.toString(base)
	return numWithBase
}



// WEBPACK FOOTER //
// ./src/assets/formulas/base.js